
  import EmployeeCreateDialogFormCard from "./EmployeeCreateDialogFormCard.vue";
  import EmployeeEmploymentForm from "../forms/EmployeeEmploymentForm.vue";
  import EmployeeExportForm from "../forms/EmployeeExportForm.vue";
  import EmployeePersonalForm from "../forms/EmployeePersonalForm.vue";
  import EmployeeWageForm from "../forms/EmployeeWageForm.vue";
  import ModalDialog from "@/components/ModalDialog.vue";

  import Employee from "@/model/Employee";
  import {computed, defineComponent, reactive, ref, toRefs} from "vue";
  import EmployeeService, {toLegacyErrorPath} from "@/service/EmployeeService";
  import {applyChangedMinimumWage, createDefaultEmployee} from "./EmployeeDefaults";
  import {MessageTypes} from "@/components/message-types";
  import {AxiosError} from "axios";
  import ValidationError from "@/model/ValidationError";
  import {t} from "@/mixin/mixins";
  import eventBus from "@/eventbus";

  export default defineComponent({
    name: "EmployeeCreateDialog",
    components: {
      EmployeeCreateDialogFormCard,
      EmployeeEmploymentForm,
      EmployeeExportForm,
      EmployeePersonalForm,
      EmployeeWageForm,
      ModalDialog
    },
    setup(props, context) {
      const errors = ref(new Map<string, string>());

      const state = reactive({
        dialog: false,
        employee: new Employee(),
        registrationUuid: null as unknown as string,
        result: (confirmed: boolean | PromiseLike<boolean>) => {
        },
        employeeErrors: computed(() => errors.value.forEach((value, key) => {
          if (!key.includes(".")) {
            errors.value.set(key, value);
          }
        })),
        employmentErrors: computed(() => errors.value.forEach((value, key) => {
          if (key.startsWith("employment.")) {
            // Only pass the prop name after wage.
            errors.value.set(key.split("employment.")[1], value);
          }
        })),
        wageErrors: computed(() => errors.value.forEach((value, key) => {
          if (key.startsWith("wage.")) {
            // Only pass the prop name after wage.
            errors.value.set(key.split("wage.")[1], value);
          }
        }))
      });

      const close = () => {
        state.dialog = false;
        state.result(false);
      };

      const open = (registrationUuid: string) => {
        state.dialog = true;
        state.registrationUuid = registrationUuid;

        createDefaultEmployee(registrationUuid)
          .then(employee => {
            Object.assign(state.employee, employee);
          });

        return new Promise<boolean>((resolve) => {
          state.result = resolve;
        });
      };

      const onWageValidFromChange = (previousValidFrom: string) => {
        applyChangedMinimumWage(state.employee.wages[0], previousValidFrom);
      };

      const save = () => {
        errors.value.clear();

        EmployeeService.createEmployee(state.employee, state.registrationUuid)
          .then(response => {
            eventBus.$emit(MessageTypes.SUCCESS, t("employee.created"), 1000);

            state.dialog = false;
            state.result(true);
          })
          .catch((error: AxiosError) => {
            if (error && error.response && error.response.status === 422) {
              eventBus.$emit(MessageTypes.WARNING, t("checkInput"));

              // @ts-ignore
              (error.response.data.errors || []).forEach((error: ValidationError) => {
                errors.value.set(toLegacyErrorPath(error.path), error.message);
              });
            } else {
              eventBus.$emit(MessageTypes.ERROR, t("employee.createError"));
            }
          });
      };

      return {...toRefs(state), close, onWageValidFromChange, open, save};
    }
  });
